import React from "react";
import SharedFormPage from "./shared-form-page";

const RoomTemplateEditPage = ({ match, ...props }) => (
  <SharedFormPage mode="edit" roomTemplateId={match.params.id} match={match} {...props} />
);

export default RoomTemplateEditPage;
